"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatusTitle = exports.UserStatusStatusEnum = void 0;
var UserStatusStatusEnum;
(function (UserStatusStatusEnum) {
    UserStatusStatusEnum[UserStatusStatusEnum["Offline"] = 0] = "Offline";
    UserStatusStatusEnum[UserStatusStatusEnum["Online"] = 1] = "Online";
    UserStatusStatusEnum[UserStatusStatusEnum["IdleMail"] = 4] = "IdleMail";
    UserStatusStatusEnum[UserStatusStatusEnum["IdleVoice"] = 8] = "IdleVoice";
    UserStatusStatusEnum[UserStatusStatusEnum["IdleForm"] = 16] = "IdleForm";
    UserStatusStatusEnum[UserStatusStatusEnum["IdleChat"] = 64] = "IdleChat";
    UserStatusStatusEnum[UserStatusStatusEnum["Idle"] = 512] = "Idle";
    UserStatusStatusEnum[UserStatusStatusEnum["PartialBusy"] = 1024] = "PartialBusy";
    UserStatusStatusEnum[UserStatusStatusEnum["HandlingConversation"] = 2048] = "HandlingConversation";
    UserStatusStatusEnum[UserStatusStatusEnum["Pinging"] = 4096] = "Pinging";
    UserStatusStatusEnum[UserStatusStatusEnum["Paused"] = 32768] = "Paused";
    UserStatusStatusEnum[UserStatusStatusEnum["BusyMail"] = 262144] = "BusyMail";
    UserStatusStatusEnum[UserStatusStatusEnum["BusyVoice"] = 524288] = "BusyVoice";
    UserStatusStatusEnum[UserStatusStatusEnum["BusyForm"] = 1048576] = "BusyForm";
    UserStatusStatusEnum[UserStatusStatusEnum["BusyChat"] = 4194304] = "BusyChat";
    UserStatusStatusEnum[UserStatusStatusEnum["Busy"] = 33554432] = "Busy";
})(UserStatusStatusEnum = exports.UserStatusStatusEnum || (exports.UserStatusStatusEnum = {}));
exports.UserStatusTitle = {
    33554432: 'BUSY',
    1048576: 'BUSY_FORM',
    524288: 'BUSY_VOICE',
    262144: 'BUSY_EMAIL',
    32768: 'PAUSED',
    4096: 'PINGING',
    2048: 'HANDLING',
    1024: 'PARTIAL_BUSY',
    512: 'IDLE',
    8: 'IDLE',
    4: 'IDLE',
    1: 'ONLINE',
    0: 'OFFLINE',
};
